import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { Typography } from '@/components/Typography/Typography';
import AlertOrangeIcon from '@/images/AlertOrangeIcon.svg?react';
import { COLORS } from '@/styles/colors';
import { IconWrapper } from './styles';
import { Notification } from '@/components/Notification/Notification';
import { addDays, parseISO } from 'date-fns';
import { SUBSCRIPTION_GRACE_PERIOD_DAYS } from '@/const/shared';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';

type GracePeriodNotificationType = {
  onRetryPayment: () => void;
  onCustomerPortalNavigate: () => void;
  subscriptionExpirationDate: string;
  isLoading: boolean;
};

export const SubscriptionGraceNotification = ({
  onRetryPayment,
  onCustomerPortalNavigate,
  subscriptionExpirationDate,
  isLoading,
}: GracePeriodNotificationType) => {
  const expirationDate = subscriptionExpirationDate
    ? addDays(parseISO(subscriptionExpirationDate), SUBSCRIPTION_GRACE_PERIOD_DAYS)
    : null;
  const formattedExpirationDate = formatDate(expirationDate);

  return (
    <Notification
      variant='info-tertiary'
      icon={
        <IconWrapper>
          <AlertOrangeIcon />
        </IconWrapper>
      }
    >
      <Box width='100%' display='flex' alignItems='center' justifyContent='space-between' columnGap='20px'>
        <Box display='flex' flexDirection='column'>
          <Typography color={COLORS.grey[950]} fontWeight='semibold'>
            Payment failed — your subscription is in grace period.
          </Typography>
          <Typography color={COLORS.grey[700]} variant='bodySmall'>
            We couldn`t process your subscription payment. If your card is correct, please ensure it has sufficient
            balance and <b>retry the payment</b>. If your card is expired or blocked, please{' '}
            <NavigationLink to='' onClick={onCustomerPortalNavigate}>
              update your payment method
            </NavigationLink>{' '}
            in the Stripe Customer Portal and then <b>retry the payment</b> there. You will have full access until the
            grace period expires on <b>{formattedExpirationDate}</b>. After that, your organization account will be
            restricted to <b>view-only mode</b>.
          </Typography>
        </Box>
        <Box display='flex' flexShrink={0}>
          <Button width='164px' size='medium' onClick={onRetryPayment} isLoading={isLoading}>
            Retry the payment
          </Button>
        </Box>
      </Box>
    </Notification>
  );
};
